import React, { FC } from 'react'

import { CoachOverviewHeadWrapper } from './styled'
import CoachOverviwHeadTab from './CoachOverviwHeadTab'
import CoachOverviewHeadInfo from './CoachOverviewHeadInfo'
import CoachOverviewHeadCrumbs from './CoachOverviewHeadCrumbs'
import NewUserFilesItems from '../../../Users/NewUser/NewUsersComponents/NewUserFilesItems'

const CoachOverviewHead: FC = () => {
	return (
		<CoachOverviewHeadWrapper component={'header'}>
			<CoachOverviewHeadCrumbs />

			<CoachOverviewHeadInfo uploadsSlot={<NewUserFilesItems />} />

			<CoachOverviwHeadTab />
		</CoachOverviewHeadWrapper>
	)
}

export default CoachOverviewHead
